import { useTranslations } from 'next-intl'

import { RoomDiscount } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Title, List, Item } from '../common/layout'

const useRoomDiscounts = () => {
  const t = useTranslations('common')

  const ROOM_DISCOUNTS = [
    {
      title: t('discount.long_term'),
      value: RoomDiscount.LONG_TERM,
    },
    {
      title: t('discount.immediate'),
      value: RoomDiscount.EARLY,
    },
  ]

  return { ROOM_DISCOUNTS }
}

type Props = {
  className?: string
}

export const RoomDiscounts = ({ className }: Props) => {
  const t = useTranslations('filter')

  const { ROOM_DISCOUNTS } = useRoomDiscounts()

  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { roomDiscounts },
    updateFilter,
  } = useFilter()

  const handleRoomDiscountChange = (value: RoomDiscount) => () => {
    updateFilter({ roomDiscounts: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.RoomDiscounts, element)
        }
      }}
    >
      <Title>{t('discount.title')}</Title>
      <List>
        {ROOM_DISCOUNTS.map(({ title, value }) => (
          <Item
            key={value}
            type={type}
            selected={roomDiscounts.includes(value)}
            onClick={handleRoomDiscountChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
